// import { format } from 'core-js/core/date'
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

let kejianrouter = new Router({
  routes: [{
      path: '/',
      name: 'home',
      component: () => import('@/views/Home.vue')
    },
    {
      path: '/news',
      name: 'news',
      component: () => import('@/views/News.vue'),
    },
    {
      path: '/product',
      name: 'product',
      component: () => import('@/views/Product.vue'),
    },
    {
        path: '/productdetail',
        name: 'productdetail',
        component: () => import('@/views/productDetail.vue'),
      },
    {
      path: '/case',
      name: 'case',
      component: () => import('@/views/Case.vue')
    },
    
    {
      path: '/earthdetail',
      name: 'earthdetail',
      component: () => import('@/views/earthDetail.vue')
    },
    {
        path: '/goin',
        name: 'goin',
        component: () => import('@/views/GoIn.vue')
    },
    {
        path: '/mentally',
        name: 'mentally',
        component: () => import('@/views/mentally.vue')
    },
    {
        path: '/physics',
        name: 'physics',
        component: () => import('@/views/physics.vue')
    },
    
    {
      path: '/download',
      name: 'download',
      component: () => import('@/views/Download.vue')
    },
    {
      path: '/consultationDetails',
      name: 'consultationDetails',
      component: () => import('@/views/consultationDetails.vue')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login.vue')
    },
  ]
})

// // 判断是否需要登录权限 以及是否登录
// kejianrouter.beforeEach((to, from, next) => {
//   // 判断是否需要登录权限
//   if (to.matched.some(res => res.meta.requireAuth)) {
//     // 判断是否登录
//     if (sessionStorage.getItem('token')) {
//       next()
//     } else {
//       // 没登录则跳转到登录界面
//       next({
//         path: '/login',
//         query: {
//           redirect: to.fullPath
//         }
//       })
//     }
//   } else {
//     next()
//   }
// })
kejianrouter.beforeEach((to, from, next) => {
    document.body.scrollTop = 0; 
    document.documentElement.scrollTop = 0; 
    window.pageYOffset = 0;
    if(to.matched.length === 0) {
        from.path ? next({path:format.path}) : next('/home')
    } else {
        next();
    }
   
  });
export default kejianrouter